// extracted by mini-css-extract-plugin
export default {"drop-zone-icon":"drop-zone-icon_SrhyvUtz","drop-zone-message-container":"drop-zone-message-container_CmRFyPwi","drop-zone_content":"drop-zone_content_zCDuVSQC"};